import './Descriptions.scss';

const Descriptions = () => {
    return(
        <section className="Descriptions">
            <div className="Descriptions-about">
                <h6>/ABOUT THE PROJECT</h6>
                <p className="Descriptions-about-p">
                    <span className="Descriptions-about-p-purple">
                         FOR THE ERC 2026 COMPETITION,
                         UCU ROVER TEAM CREATED 
                    </span>
                    THE INDOMITUS ROVER,
                    <span className="Descriptions-about-p-purple">
                        EQUIPPED WITH A DRONE AND A ROBOTIC ARM.
                    </span>
                </p>
            </div>
            <div className="Descriptions-about">
                <h6>/TIMELINE & PLACE</h6>
                <p className="Descriptions-about-p">
                    JANUARY 2026 - SEPTEMBER 2026,
                    UKRAINIAN CATHOLIC UNIVERSITY, <br/>
                    <span className="Descriptions-about-p-purple">
                           LVIV, UKRAINE
                    </span>
                </p>
            </div>
        </section>
    )
};
export default Descriptions;